import React, { useState } from 'react';
import Slider from 'react-slick';
import Carousel, { Modal, ModalGateway } from 'react-images';
import CustomModal from './CustomModal';
import Image from './Image';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ImageSlider = ({
  images,
  sliderClass,
  video,
  toggleImagesModal,
  imagesModal,
  floorplan,
  sliderText,
}) => {
  const customVideoStyles = {
    navigationNext: (base) => ({
      ...base,
      right: 200,
      height: 10000
    }),
    view: (base) => ({ ...base, textAlign: 'center' }),
    navigationPrev: (base) => ({
      ...base,
      height: 400,
      width: 600
    })
  }
  const CarouselImageLabel = (carouselProps) => (
    <div className='carousel-image-label'>
      {images[carouselProps.currentIndex].label}
    </div>
  );
  const MultiVideoView = (carouselProps) => {
    return (
      <iframe
        title={`https://www.youtube.com/embed/${carouselProps.currentView}`}
        className='multi-video-slider'
        src={`https://www.youtube.com/embed/${carouselProps.currentView}`}
        autoplay='true'
        frameBorder='0'
        allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen></iframe>
    );
  };
  const modalImages = images.map((image) => ({ src: image.image }));
  const modalFloorplan = !!floorplan
    ? floorplan.map((image) => ({ src: image.image }))
    : null;

  const [isVideoModalOpen, setVideoModalStatus] = useState(false);
  const toggleVideoModal = () => {
    if (isVideoModalOpen) {
      return setVideoModalStatus(false);
    }
    return setVideoModalStatus(true);
  };

  const [isFloorplanModalOpen, setFloorplanModalStatus] = useState(false);
  const toggleFloorplanModal = () => {
    if (isFloorplanModalOpen) {
      return setFloorplanModalStatus(false);
    }
    return setFloorplanModalStatus(true);
  };

  const renderFloorplan = () => {
    if (!floorplan || floorplan === '') {
      return null;
    }
    return (
      <ModalGateway>
        {isFloorplanModalOpen ? (
          <Modal onClose={toggleFloorplanModal} closeOnBackdropClick>
            <Carousel
              styles={{ view: () => ({ maxWidth: '70vw', margin: '0 auto', maxHeight: '90vh', objectFit: 'contain' }) }}
              currentIndex={imagesModal.index}
              views={modalFloorplan}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    );
  };

  const renderVideos = () => {
    if (!video) {
      return null;
    }
    if (video.indexOf(',') > -1) {
      const videoArray = video.split(', ');
      return (
        <ModalGateway>
          {isVideoModalOpen ? (
            <Modal onClose={toggleVideoModal} closeOnBackdropClick>
              <Carousel
                styles={ customVideoStyles }
                currentIndex={imagesModal.index}
                views={videoArray}
                interactionIsIdle={false}
                components={{ View: MultiVideoView }}
              />
            </Modal>
          ) : null}
        </ModalGateway>
      );
    }
    return (
      <CustomModal onClose={toggleVideoModal} isOpen={isVideoModalOpen}>
        <iframe
          className='youtube-embed'
          title={`https://www.youtube.com/embed/${video}`}
          src={`https://www.youtube.com/embed/${video}`}
          autoPlay
          frameBorder='0'
          allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen></iframe>
      </CustomModal>
    );
  };
  const config = {
    dots: false,
    dotsClass: 'slick-dots',
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  };

  return (
    <div>
      <Slider {...config}>
        {images.map((image, index) => (
          <div
            className={sliderClass}
            onClick={() => toggleImagesModal(index)}
            key={`slider-image-${index}`}>
            <Image
              classes={'slider-image'}
              imageInfo={{ image: image.image }}
            />
            <div>{image.label}</div>
          </div>
        ))}
      </Slider>
      <ModalGateway>
        {imagesModal.isOpen ? (
          <Modal onClose={toggleImagesModal} closeOnBackdropClick>
            <Carousel
              styles={{
                view: () => ({
                  margin: '0 auto',
                  maxWidth: '90vw',
                  '@media all and (min-width: 320px)': { maxWidth: '80vw' },
                  '@media all and (min-width: 1025px)': { maxWidth: '60vw' },
                  '@media all and (min-width: 2560px)': { maxWidth: '50vw' },
                  '@media all and (min-width: 3440px)': { maxWidth: '40vw' },
                  '@media all and (min-width: 4500px)': { maxWidth: '30vw' },
                }),
              }}
              currentIndex={imagesModal.index}
              views={modalImages}
              components={{ Footer: CarouselImageLabel }}
            />
          </Modal>
        ) : null}
      </ModalGateway>
      <div className='slider-buttons hide-element'>
        <span className='slider-photos' onClick={() => toggleImagesModal()}>
          {sliderText.photo}
        </span>
        {!!floorplan && floorplan.length > 0 ? (
          <span
            className='slider-floorplan'
            onClick={() => toggleFloorplanModal()}>
            {' '}
            | {sliderText.floorplan}
          </span>
        ) : null}
        {!!video ? (
          <span className='slider-video' onClick={() => toggleVideoModal()}>
            {' '}
            | {sliderText.video}
          </span>
        ) : null}
      </div>
      {renderVideos()}
      {renderFloorplan()}
    </div>
  );
};

export default ImageSlider;
